export default __webpack_public_path__ + "static/media/opensans.5575f656.woff";